import { Lightning } from '@lightningjs/sdk';

export class CmsCardIcon extends Lightning.Component {
  static _template() {
    return {
      w: 24,
      h: 24,
    };
  }

  set icon(icon) {
    this.src = icon;
  }
}
